var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-container',{staticClass:"py-2"},[_c('UserOverview',{attrs:{"type":_vm.type,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }